export enum ReportTypeEnum {
  none = 'none',
  summary = 'summary',
  detailed = 'detailed',
}

export namespace ReportTypeEnum {
  export function mapFromApiValue(value: string): ReportTypeEnum {
    if (Object.values(ReportTypeEnum).includes(value as ReportTypeEnum)) {
      return value as ReportTypeEnum;
    }
    return ReportTypeEnum.summary;
  }
}
